/**
 * The tabs panel type: a container whose tab bar switches between other panels on the page.
 */

/* No fields: the block holds a list of child panels, which is checked against the rest of the page
   rather than field by field. */
const tabs = {
  names: [{ id: 'tabs', label: 'Tabs', guide: 'tabs.md', container: true, advanced: false, toolSummary: 'a container whose tab bar switches between other panels on this page', promptSummary: 'a container whose tab bar switches between other panels on this page' }],
  block: 'tabs',
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['items'],
    description: 'Tabs container config (displayType "tabs"): full replacement of the tab list, in order. Each item names a child panel on this page; that panel leaves the grid and renders inside this container when its tab is active. A child may itself be a container (a tab holding a group is a normal shape), but no panel can live in two containers and nothing may contain itself. Pass null to clear the tabs and release every child back to the grid. Read immutable/analytics/panel-types/tabs.md before the first tabs config.',
    properties: {
      items: {
        type: 'array',
        description: 'The tabs, in display order.',
        items: {
          type: 'object',
          additionalProperties: false,
          required: ['panelId'],
          properties: {
            panelId: { type: 'string', description: 'Child panel id from analytics_page_get or analytics_panel_create.' },
            label: { type: ['string', 'null'], description: "Tab label. Omit to use the child panel's own name." }
          }
        }
      }
    }
  }
};

export default tabs;
